import React from 'react';
import './SpaceEnterButton.css';

const SpaceEnterButton = ({ onClick, label = 'ENTER' }) => {
  return (
    <button type="button" className="space-enter-btn" onClick={onClick}>
      <strong>{label}</strong>
      <div className="space-enter-btn__stars-wrap" aria-hidden="true">
        <div className="space-enter-btn__stars" />
      </div>
      <div className="space-enter-btn__glow" aria-hidden="true">
        <div className="space-enter-btn__circle" />
        <div className="space-enter-btn__circle" />
      </div>
    </button>
  );
};

export default SpaceEnterButton;